









































import { ObjectFactory } from '@/config/objectFactory';
import { EventBus } from '@/main';
import { ToastEvent } from '@/types/event';
import { ApiRequest, UpdateQuestionnaireRequest } from '@/types/request';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { Component, Vue } from 'vue-property-decorator';
import { required, numeric } from 'vuelidate/lib/validators';
// tslint:disable-next-line: no-var-requires
const ProfileFormData = require('../../config/ProfileFormData');
@Component({
    props: {
        question: Object,
    },
    validations() {
        const question = this.$props.question;
        return {
            answer: {
                required,
                numeric: (question.question.startsWith('How much') ||
                question.question.startsWith('How many')) ? numeric : {},
            },
        };
    },
    data() {
        return {
            questionName: '',
            answer: '',
        };
    },
})
export default class UpdateQuestionnaireModal extends Vue {
    private show = true;
    private questionnaires = [
        ...ProfileFormData.questionnaires,
        ...ProfileFormData.homeHealthCareQuestionnaires,
        ...ProfileFormData.subQuestions.Stretcher,
        ...ProfileFormData.subQuestions.Wheelchair,
    ];
    private questionObj: any = null;
    private providerType: 'transporter' | 'homeHealthcare' = '' as any;
    public mounted() {
        this.show = true;
        this.$data.questionName = this.$props.question.question;
        this.$data.answer = this.$props.question.answer;
        if (ProfileFormData.questionnaires.some((element: any) => element.question === this.$data.questionName)) {
            this.providerType = 'transporter';
        } else if (ProfileFormData.subQuestions.Stretcher.some
            ((element: any) => element.question === this.$data.questionName) ||
                ProfileFormData.subQuestions.Wheelchair.some
            ((element: any) => element.question === this.$data.questionName)) {
            this.providerType = 'transporter';
        } else if (ProfileFormData.homeHealthCareQuestionnaires.some
            ((element: any) => element.question === this.$data.questionName)) {
            this.providerType = 'homeHealthcare';
        }
        this.questionObj = this.questionnaires.find((element: any) => {
            return element.question === this.$data.questionName;
        });
        if (this.questionObj && this.questionObj.type === 'tabs') {
            this.$data.answer = this.$data.answer.split(',');
        }
    }
    private async updateQuestionnaire() {
        const iHttpService = ObjectFactory.getHttpService();
        const updateQuestionnaireRequest: UpdateQuestionnaireRequest = {
            question: this.$data.questionName,
            answer: this.$data.answer,
        };
        if (this.questionObj && this.questionObj.type === 'tabs') {
            updateQuestionnaireRequest.answer = updateQuestionnaireRequest.answer.toString();
        }
        let url = '';
        if (this.providerType === 'transporter') {
            url = `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/questionnaire`;
        } else {
            url = `/v1/homehealthcareproviders/questionnaire`;
        }
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url,
            data: updateQuestionnaireRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<any>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Questionnaire updated successfully..',
                title: 'Success!',
                timeout: 5000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }
    private close() {
        this.$emit('close');
    }
}
